<app-modal #modal [modalConfig]="modalConfig">
  <ng-container *ngIf="purchaseLimitRule$ | async as purchaseLimitRule">
    <div class="modal-backdrop-custom" (click)="dismiss()"></div>
    <div class="modal-custom" role="dialog" aria-modal="true">
      <div class="modal-dialog" (click)="$event.stopPropagation()">
        <div class="modal-content">
          <button type="button" class="close-btn" (click)="dismiss()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="purchase-limit-icon-circle">
            <img
              class="icon img-fluid"
              alt="Warning"
              src="assets/images/icons/alert-icon-warning.png"
            />
          </div>

          <div
            *ngIf="purchaseLimitRule.data.errorMessage; else defaultErrorMessage"
            class="purchase-limit-message"
            [innerHtml]="purchaseLimitRule.data.errorMessage | safeHtml"
          ></div>

          <ng-template #defaultErrorMessage>
            <div
              *ngIf="purchaseLimitRule.data.errorCode === ModalType.PurchaseLimitExceeded"
              i18n
              class="purchase-limit-message"
            >
              We're sorry, {{ purchaseLimitRule.data.skuCode }} -
              {{ purchaseLimitRule.data.description }} is a limited item that just sold out, you
              cannot add it to your cart!
            </div>
            <div
              *ngIf="purchaseLimitRule.data.errorCode === ModalType.PurchaseLimitPartial"
              i18n
              class="purchase-limit-message"
            >
              This {{ purchaseLimitRule.data.skuCode }} -
              {{ purchaseLimitRule.data.description }} is a limited item and we only have
              {{ purchaseLimitRule.data.allowedQuantity }} left. Would you like to add them to you
              order?
            </div>
            <div
              *ngIf="purchaseLimitRule.data.errorCode === ModalType.PurchaseLimitBackorderOnly"
              i18n
              class="purchase-limit-message"
            >
              {{ purchaseLimitRule.data.skuCode }} - {{ purchaseLimitRule.data.description }} is a
              limited item that just sold out, but you can add it as a backorder. Would you like to
              proceed?
            </div>
            <div
              *ngIf="purchaseLimitRule.data.errorCode === ModalType.PurchaseLimitBackorderPartial"
              i18n
              class="purchase-limit-message"
            >
              We are sorry that this is a limited item and we only have
              {{ purchaseLimitRule.data.allowedQuantity }} left. Would you like to add them to you
              order as regular purchase and the rest of the items as backorder items?
            </div>
          </ng-template>

          <div class="qty-btn-wrapper">
            <button type="button" class="qty-btn-ok" (click)="ok()" i18n>OK</button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</app-modal>
